import type { HttpHandler } from "msw";
import {
  getBasePathWithTrailingSlash,
  isLocalDev,
  isMockApiEnabled,
} from "common/env";

// Debug is helpful to setup api endpoints but annoying otherwise.
const DEBUG_UNHANDLED_REQUEST = false;

const loadAndStartMockServiceWorker = async () => {
  const { setupWorker } = await import("msw/browser");
  const fileName = "handlers";
  const handlersPromise = (await import(
    `./handlers/${fileName}.ts`
  )) as Promise<{
    handlers: Promise<HttpHandler[]>;
  }>;
  const handlerImport = await handlersPromise;
  const worker = setupWorker(...(await handlerImport.handlers));

  const options = {
    serviceWorker: {
      url: `${getBasePathWithTrailingSlash()}mockServiceWorker.js`,
    },
    ...(DEBUG_UNHANDLED_REQUEST
      ? {}
      : { onUnhandledRequest: "bypass" as const }),
  };
  return await worker.start(options);
};

// Start the mocking conditionally. Exported so Main.tsx can await readiness
// before creating the router; see VST-103842.
export const mockApiReady = (async () => {
  if (isLocalDev() && isMockApiEnabled()) {
    try {
      await loadAndStartMockServiceWorker();
    } catch (e) {
      // eslint-disable-next-line
      console.error(`MSW setup failed: `, e);
    }
  }
})();
